import { MaterialIcon } from '@components';
import { Stack, Typography, Button } from '@mui/material';

interface AssessmentReportRevokeSelectionProps {
  selected: string[];
  total: number;
  triggeredSelectAll: boolean;
  realSelectedAll: boolean;
  onClear: () => void;
  onRealSelectAll: () => void;
  onRevoke: () => void;
}

export default function AssessmentReportRevokeSelection({
  selected,
  total,
  triggeredSelectAll,
  realSelectedAll,
  onClear,
  onRealSelectAll,
  onRevoke,
}: AssessmentReportRevokeSelectionProps) {
  const totalSelected = realSelectedAll ? total : selected.length;
  const allSelected = totalSelected === total;

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      <Stack direction="row" alignItems="center" py={'1px'} spacing={1}>
        <Typography variant="body2">
          Selected {allSelected ? `all ${totalSelected}` : `${selected.length}`} items
        </Typography>
        {triggeredSelectAll && !allSelected && total > 0 && (
          <Button onClick={onRealSelectAll} variant="text">
            Select all {total} items
          </Button>
        )}
        <Button onClick={onClear} variant="text" endIcon={<MaterialIcon symbol="clear" />}>
          Clear Selection
        </Button>
      </Stack>
      <Button
        onClick={onRevoke}
        variant="contained"
        color="primary"
        endIcon={<MaterialIcon symbol="arrow_right_alt" />}
      >
        Revoke
      </Button>
    </Stack>
  );
}
